import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { adminLogin, fetchMe, setToken, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = admin
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!getToken()) { setUser(false); setReady(true); return; }
      try {
        const me = await fetchMe();
        setUser(me);
      } catch {
        clearToken();
        setUser(false);
      }
      setReady(true);
    };
    check();
  }, []);

  const login = useCallback(async (email, password) => {
    const { token, user } = await adminLogin(email, password);
    setToken(token);
    setUser(user);
    return user;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setUser(false);
  }, []);

  const setSession = useCallback((token, u) => {
    setToken(token);
    setUser(u);
  }, []);

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, setSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
